import { mimeTypeFilter } from "@/filters/dictionaryFilters";
import { Message } from "element-ui";
import { isArray, isObject, isString, notEmpty } from "./type";

export function showMessage(message, type = "success", showClose = true) {
  Message({
    message,
    type,
    showClose,
  });
}

/**
 * 滚动条在Y轴上的滚动距离
 */
export function getScrollTop() {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}

/**
 * 文档的总高度
 */
export function getScrollHeight() {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight = bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
  return scrollHeight;
}

/**
 * 浏览器视口的高度
 */
export function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}

/**
 * 下载文件
 * @param {*} fileUrl 完整路径
 * @param {*} fileName 修改文件名称
 */
export function downloadFile(fileUrl, fileName) {
  const x = new window.XMLHttpRequest();
  x.open("GET", fileUrl, true);
  x.responseType = "blob";
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = fileName;
    a.style.display = "none";
    document.body.append(a);
    a.click();
  };
  x.send();
  window.vue.$message.info("下载中...");
  x.onerror = e => {
    console.error(e);
    window.vue.$message.error("下载失败!");
  };
}

/**
 * 是否有权限
 * @param {string} role
 * @returns boolean
 */
export function hasPermission(role) {
  return true;
}

export function noPermission(role) {
  return !hasPermission(role);
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (notEmpty(actual[i])) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * 获取媒体类型
 * @param {String} str
 * @param {Boolean} 是否返回OTHER
 */
export function getMimeType(str, showOther = true) {
  if (isString(str) && notEmpty(str)) {
    let index = str.lastIndexOf("."),
      val = (index < str.length ? str.slice(index + 1) : str).toUpperCase();
    return mimeTypeFilter(val, showOther);
  } else {
    return "";
  }
}

export function getFileInfo(tar, imgKeys, fileKeys) {
  let keys = [...imgKeys, ...fileKeys];
  keys.forEach(key => {
    if (Object.hasOwnProperty.call(tar, key)) {
      // console.log("getFileInfo", key, tar[key]);
      let item = tar[key];
      if (isString(item) && notEmpty(item)) {
        if (item[0] === "[" && item[item.length - 1] === "]") {
          try {
            let arr = JSON.parse(tar[key]),
              newArr = [];
            arr.forEach((file, index) => {
              if (imgKeys.includes(key)) {
                if (isObject(file) && file.url) {
                  newArr.push(file.url.replace(/^(http:\/\/)/, "https://"));
                } else if (isString(file)) {
                  newArr.push(file.replace(/^(http:\/\/)/, "https://"));
                }
              } else {
                if (isObject(file) && file.url) {
                  newArr.push({ name: file.name, url: file.url.replace(/^(http:\/\/)/, "https://") });
                } else if (isString(file)) {
                  let extension = "";
                  try {
                    extension = file.slice(file.lastIndexOf("."));
                  } catch (error) {
                    console.error(error);
                  }
                  newArr.push({
                    name: "文件" + (index + 1) + (extension || ""),
                    url: file.replace(/^(http:\/\/)/, "https://"),
                  });
                }
              }
            });
            tar[key] = newArr;
          } catch (error) {
            console.error(error);
            tar[key] = [];
          }
        } else {
          let newArr = [],
            out = [];
          if (item.includes(",")) {
            try {
              newArr = item.split(",");
            } catch (error) {
              console.error(error);
            }
          } else {
            newArr = [item];
          }
          item.split(",").forEach((file, index) => {
            if (imgKeys.includes(key)) {
              out.push(file.replace(/^(http:\/\/)/, "https://"));
            } else {
              let extension = "";
              try {
                extension = file.slice(file.lastIndexOf("."));
              } catch (error) {
                console.error(error);
              }
              out.push({
                name: "文件" + (index + 1) + (extension || ""),
                url: file.replace(/^(http:\/\/)/, "https://"),
              });
            }
          });
          tar[key] = out;
        }
      } else {
        tar[key] = [];
      }
    }
  });
}

export function getImagePreviewList(arr) {
  let out = [];
  if (notEmpty(arr)) {
    if (isArray(arr)) {
      arr.forEach(item => {
        out.push(item);
      });
    } else if (isString(arr)) {
      return [arr];
    }
  }
  return out;
}

export function htmlTextToText(htmlText) {
  if (htmlText && isString(htmlText)) {
    try {
      let div = document.createElement("div");
      div.innerHTML = htmlText;
      let str = div.innerText;
      return str;
    } catch (error) {
      console.error(error);
      return "";
    }
  }
  return "";
}

export function animateCSS(element, animation, prefix = "animate__") {
  // We create a Promise and return it
  return new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    let node = element;
    if (!node) return;
    node.classList.add("wow", `${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      resolve("Animation ended");
    }

    node.addEventListener("animationend", handleAnimationEnd, { once: true });
  });
}
export function addWOW(boxClass = "wow", animateClass = "animate__animated", offset = 0, live = true) {
  window.vue.$nextTick(() => {
    new window.vue.$wow.WOW({
      boxClass,
      animateClass,
      offset,
      live,
    }).init();
  });
}

/**
 * 检查标准选项数据
 * @param {Array} list 要检查的数组
 * @param {String} labelKey 要检查的属性
 * @param {String} valueKey 要检查的数据
 * @param {String} childrenKey 子数组属性
 * @returns {Array} 检查过的数组
 */
export function checkOptions(list, labelKey = "name", valueKey = "id", childrenKey = "children") {
  var arr = [];
  if (notEmpty(list)) {
    list.forEach(item => {
      var obj = JSON.parse(JSON.stringify(item));
      obj.label = item[labelKey];
      obj.value = item[valueKey];
      obj.children = null;
      if (childrenKey && notEmpty(item[childrenKey])) {
        obj.children = checkOptions(item[childrenKey], labelKey, valueKey, childrenKey);
      }
      arr.push(obj);
    });
  }
  return arr;
}
